
import { fetchGetJson, fetchPost } from "../../utils/fetch-json.js"
import { createFormData } from "../../utils/formdata.js"

export const LikeService = {
    like: (userId: string, recordId: string) =>
        fetchPost(`/v1/r/${recordId}/like`, createFormData({ userId: userId, recordId: recordId })),

    unlike: (userId: string, recordId: string) =>
        fetchPost(`/v1/r/${recordId}/unlike`, createFormData({ userId: userId, recordId: recordId })),

    getLikedUsers: (recordId: string) =>
        fetchGetJson(`/v1/r/${recordId}/listLiked`)
}
